<template>
  <div class="record-detail-main">
    <NavBar>
      <template slot="content">
        <div>喜报</div>
      </template>
      <template slot="right" v-if="previewOrderImg && isApp">
        <img
          src="./img/share3.png"
          class="record-detail-nav-right"
          @click="$refs.shareWx.show = true"
        />
      </template>
    </NavBar>
    <div class="record-detail-content">
      <img :src="previewOrderImg" class="record-detail-img" />
    </div>
    <ShareWx ref="shareWx" @handleShare="handleShare" />
  </div>
</template>
<script>
import NavBar from '@/components/h5header'
import ShareWx from '@/components/ShareWx'
import weixinShareImage from '@/services/h5/app-api/weixinShareImage.js'
import { isApp } from '@/utils/platform'
export default {
  components: { NavBar, ShareWx },
  data() {
    return {
      isApp
    }
  },
  computed: {
    previewOrderImg() {
      return this.$route.query.previewOrderImg
    }
  },
  methods: {
    handleShare(val) {
      weixinShareImage({
        shareType: val,
        imageUrl: this.$route.query.previewOrderImg
      })
    }
  }
}
</script>
<style scoped lang="less">
.record-detail-main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.record-detail-content {
  flex: 1;
}
.record-detail-img {
  width: 375px;
  height: 100%;
}
.record-detail-nav-right {
  width: 18px;
  height: 18px;
}
</style>
